import { Tabs, Tag } from "antd";

import "../styles.css";

import { BANKS, BankContext } from "./BankContext";
import CategoryQuestionsTab from "./CategoryQuestionsTab";
import ConfigTab from "./ConfigTab";
import GenerateTab from "./GenerateTab";
import ImportTab from "./ImportTab";
import JsonTab from "./JsonTab";
import ReviewTab from "./ReviewTab";
import StatsTab from "./StatsTab";

/**
 * Play Quizzes & Earn — question-bank admin. One SEPARATE sidebar page per
 * app (no in-page switcher, to avoid editing the wrong app's bank):
 *   "Quiz & Earn"  → <QuizConfig />                     (MiniPix English,
 *                    config_key "default")
 *   "Quiz App (Reasoning)" → <QuizConfig bankValue="reasoning" /> (standalone
 *                    MiniPix Quiz app, bilingual reasoning bank,
 *                    config_key "reasoning")
 *   "Math App"     → <QuizConfig bankValue="math" /> (standalone MiniPix
 *                    Math app, bilingual math bank with server-side
 *                    arithmetic verification, config_key "math")
 * Questions are Gemini-drafted into a review queue and served to the app
 * ONLY after admin approval. Coins credit through the same AG ledger
 * (taskCategory QUIZ, its own daily cap).
 */
const QuizConfig = ({ bankValue = "english" }) => {
  const bank = BANKS.find((b) => b.value === bankValue) || BANKS[0];
  return (
    <div className="manage-tasks">
      <Tag
        color={{ reasoning: "purple", math: "green" }[bank.bank] || "blue"}
        style={{ marginBottom: 12 }}
      >
        {bank.label}
      </Tag>
      <BankContext.Provider value={bank}>
        <Tabs
          defaultActiveKey="config"
          items={[
            { key: "config", label: "Config & Levels", children: <ConfigTab /> },
            { key: "generate", label: "Generate (Gemini)", children: <GenerateTab /> },
            { key: "categories", label: "Category questions", children: <CategoryQuestionsTab /> },
            { key: "import", label: "Import (JSON)", children: <ImportTab /> },
            { key: "review", label: "Review Queue", children: <ReviewTab /> },
            { key: "stats", label: "Stats", children: <StatsTab /> },
            { key: "json", label: "Raw JSON", children: <JsonTab /> },
          ]}
        />
      </BankContext.Provider>
    </div>
  );
};

export default QuizConfig;
